import { AxiosPromise } from 'axios';
import {
    CreateContactOwnerRequest,
    DeleteContactOwnerRequest,
    SwapContactOwnerRequest,
} from '../../types/ContactOwner';
import { libApiInstance } from '../axios';

export function requestCreateContactOwner(
    data: CreateContactOwnerRequest,
    signal?: AbortSignal,
): AxiosPromise<number> {
    return libApiInstance.post(`/contacts/${data.contactId}/owner`, data, {
        signal,
    });
}

export function requestSwapContactOwner(
    contactId: number,
    payload: SwapContactOwnerRequest,
    signal?: AbortSignal,
): AxiosPromise<number> {
    return libApiInstance.post(`/contacts/${contactId}/swapowner`, payload, {
        signal,
    });
}

export function requestDeleteContactOwnerFromFollowers(
    data: DeleteContactOwnerRequest,
    contactId: number,
    signal?: AbortSignal,
): AxiosPromise<unknown> {
    return libApiInstance.delete(`/contacts/${contactId}/owner`, {
        data,
        signal,
    });
}
